import { useCart } from "app/hooks/checkout/useCart";
import { useSearchParams } from "react-router-dom";
import {
  CreateCartPayload,
  GetOrderResponse,
} from "shared/api/middleware-api-client";
import { useAnalytics } from "./useAnalytics";

export const useOnPurchase = () => {
  const { onPurchase, onStandardOrderPurchase } = useAnalytics();
  const { getCart, setCartToDefault } = useCart();
  const [searchParams, setSearchParams] = useSearchParams();

  const sendOnDoorPurchaseAnalytics = (order: GetOrderResponse | undefined) => {
    if (searchParams.get("orderAnalyticsConfirmation") !== "sent") {
      // Add orderAnalyticsConfirmation
      // so for the same order the datalayer wont be pushed multiple times
      const newSearchParams = new URLSearchParams(searchParams);

      newSearchParams.set("orderAnalyticsConfirmation", "sent");

      setSearchParams(newSearchParams);

      // Send analytics
      onPurchase(order);

      //remove order id, payment url
      localStorage.clear();

      // Reset cart
      setCartToDefault();
    }
  };

  const sendOnStandardOrderPurchaseAnalytics = (
    order: { id: string; orderNumber: string },
    cart: CreateCartPayload,
  ) => {
    if (searchParams.get("orderAnalyticsConfirmation") !== "sent") {
      // Add orderAnalyticsConfirmation
      // so for the same order the datalayer wont be pushed multiple times
      const newSearchParams = new URLSearchParams(searchParams);

      newSearchParams.set("orderAnalyticsConfirmation", "sent");

      setSearchParams(newSearchParams);

      // Send analytics
      onStandardOrderPurchase(order, cart);

      //remove order id, payment url
      localStorage.clear();

      // Reset cart
      setCartToDefault();
    }
  };

  return {
    sendOnDoorPurchaseAnalytics,
    sendOnStandardOrderPurchaseAnalytics,
  };
};
